if (!customElements.get('pickup-availability-check')) {
  customElements.define(
    'pickup-availability-check',
    class PickupAvailabilityCheck extends HTMLElement {
      constructor() {
        super();

        const variantId = this.dataset.variantId;
        if (!variantId) return;

        this.fetchAvailability(variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl || window.Shopify?.routes?.root || '/';
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }

        const sectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability-check`;

        fetch(sectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');

            if (!sectionInnerHTML) return;

            const content = sectionInnerHTML.querySelector('[data-pickup-availability-check]');

            if (!content) {
              this.innerHTML = '';
              this.removeAttribute('available');
              return;
            }

            this.innerHTML = content.outerHTML;
            this.setAttribute('available', '');
          })
          .catch((e) => {
            console.warn('Failed to load pickup-availability-check section', e);
            this.innerHTML = '';
            this.removeAttribute('available');
          });
      }

      update(variant) {
        if (variant?.id) {
          this.fetchAvailability(variant.id);
        } else {
          this.innerHTML = '';
          this.removeAttribute('available');
        }
      }
    }
  );
}

